import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { FraudModel } from '../models/fraud.model';

@Injectable()
export class FraudIncidentService extends IncidentServiceBase<FraudModel> {
    constructor() {
        super('Fraud', () => new FraudModel());
    }

    public getFraudDocuments(incidentNumberId: number) {
        return this.get('Incident/' + incidentNumberId + '/Fraud/Documents');
    }
}
